import { axiosInstance, requestConfig } from 'network/apis';
import { URL_SYSTEM } from "utils/constants";

export const callShoManagerInfo = async () => {
    try {
        return await axiosInstance(requestConfig('get', URL_SYSTEM, `/shop-manager/account`));
    } catch (error) {
        console.error('Failed to fetch shop manager info:', error);
        return { data: null }; 
    }
};

export const callEditShoManagerInfo = async (data) => {
    try {
        return await axiosInstance(requestConfig('put', URL_SYSTEM, `/shop-manager/account`, data));
    } catch (error) {
        console.error('Failed to edit shop manager info:', error);
        return { data: null };  // 에러 발생 시 기본값 반환
    }
};

